import React, { useEffect, useRef, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import dayjs from "dayjs";
import apiClient from "../../BaseUrl/apiClient.js";
import "../../css/entry.css";
import "../../css/color.css";
import TokenService from "../../service/TokenService";
import ToasterAlerts from "../../components/ToasterAlerts";
import SriyanshCardHeader from "../../components/CardHeader";
import { BoxStyle } from "../../constantVaribles/constatanvariable";
import EncryptService from "../../service/EncryptionService";
import { useLocation, useNavigate } from "react-router-dom";
import CustomTextField from "../../CustomComponant/CustomTextField ";
import DatePickerComponent from "../../CustomComponant/DateTimePickerField";
import NumericTextField from "../../CustomComponant/NeumericTextField";
import DropdownfromDatabaseList from "../../CustomComponant/DropdownfromDatabaseList";
import { useAuthentication } from "../../customHook/useAuthentecation";
import { USER_RIGHTS } from "../../constants/constants";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Box } from "@mui/material";
function IndentEdit() {
  const [varindentNumber, setvarindentNumber] = useState("");
  const [vardateofIndent, setvardateofIndent] = useState(null);
  const [varitemname, setvaritemname] = useState("");
  const [varindentItemQty, setvarindentItemQty] = useState(0);
  const [varindentItemValue, setvarindentItemValue] = useState(0);
  const [error, setError] = useState("");
  // const [dateerror, setDateError] = useState("");
  const [unit, setunit] = useState("");
  const [units, setunits] = useState([]);

  const [isChecked, setIsChecked] = useState(false);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };
  const startRef = useRef(null);
  const today = dayjs();
  const minCalDate = dayjs("2024-01-01");
  const [errors, setErrors] = useState({});
  const [consignee, setconsignee] = useState("");
  const [consignees, setconsignees] = useState([]);
  const navigate = useNavigate();
  const { state } = useLocation();
  let indentId = state.indent_id;
  const tokenServiceDetails = TokenService.getUserDetails();
  const uname = tokenServiceDetails?.uname;
  const ip = EncryptService.decrypt(sessionStorage.getItem("token1"));
  const urights = tokenServiceDetails?.userrights;
  const handleQuantityChange = (value) => {
    setvarindentItemQty(value);
    // Update errors as needed; example here:
    setErrors({
      qty:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };

  const handleValueChange = (value) => {
    setvarindentItemValue(value);
    // Update errors as needed; example here:
    setErrors({
      val:
        value && !/^(\d+(\.\d+)?)?$/.test(value)
          ? "Invalid quantity format"
          : "",
    });
  };
  const fetchUnit = async () => {
    try {
      const response = await apiClient.post("/unitList", {
        /* request payload if needed */
      });
      setunits(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
  const handleClose = () => {
    navigate("../polist", { replace: true });
  };

  // Function to fetch Consignee from the API
  const fetchConsignees = async () => {
    try {
      const response = await apiClient.post("/ConsigneeList", {
        /* request payload if needed */
      });
      setconsignees(response.data); // Assuming response.data is an array of roles
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const UpdateIndentData = async (e) => {
    e.preventDefault();
    let formErrors = {};

    if (!vardateofIndent) {
      formErrors.errDate = "Invalid Indent Date";
    }

    if (parseFloat(varindentItemQty) <= 0)
      formErrors.qty = "Qty should be more then zero";

    if (varindentItemValue.length === 0)
      formErrors.val = "Value should be more then zero";

    if (varindentItemQty.length === 0)
      formErrors.qty = "Qty should be more then zero";

    if (parseFloat(varindentItemValue) <= 0)
      formErrors.val = "Value should be more then zero";

    if (varindentNumber.length === 0)
      formErrors.indent = "Indent Number Should not be Blank";

    if (varitemname.length === 0)
      formErrors.name = "Item Name Should not be Blank";

    setErrors(formErrors);

    if (Object.keys(formErrors).length === 0) {
      const Indentdt = new Date(vardateofIndent);
      const indentreceiptdt =
        Indentdt.getFullYear() +
        "/" +
        parseInt(Indentdt.getMonth() + 1) +
        "/" +
        Indentdt.getDate();

      // console.log(varindentNumber);
      // console.log(indentreceiptdt);
      // console.log(consignee);
      // console.log(varindentItemQty);
      // console.log(varindentItemValue);
      // console.log(varitemname);
      // console.log(indentId);
      // console.log(ip);
      // console.log(uname);

      apiClient
        .post("/indentupdate", {
          vIndentNumber: varindentNumber,
          vIndentDate: indentreceiptdt,
          vConsigneeCode: consignee,
          vIndentQty: varindentItemQty,
          vIndentValue: varindentItemValue,
          vIndentItemName: varitemname,
          vIndentID: indentId,
          vip: ip,
          entryuser: uname,
          unit,
          urgency: isChecked,
        })
        .then(function (response) {
          navigate("../polist", { replace: true });
        })
        .catch(function (error) {
          setError(error);
        });
    }
  };

  const getIndentData = async (e) => {
    try {
      const response = await apiClient.post("/IndentEditDetails", {
        uname: uname,
        indentId: String(indentId),
      });
      const data = response.data[0];
      setvarindentNumber(data.IndentNumber);
      setconsignee(data.ConsigneeCode);
      setvaritemname(data.IndentItemName);
      setvarindentItemQty(data.IndentQty);
      setvarindentItemValue(data.IndentValue);
      setvardateofIndent(dayjs(data.IndentDate));
      setunit(data.unit);
      setIsChecked(data.urgency === 1 ? true : false);
      //console.log(data.urgency);
    } catch (error) {
      setError(error);
    }
  };

  useEffect(() => {
    if (startRef.current) {
      startRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
      
    }
    fetchConsignees();
    getIndentData();
    fetchUnit();

    


  }, []);
  const { auth } = useAuthentication();

  const handleDateChange = (newDate, setDate) => {
    if (newDate) {
      setDate(newDate);
      setErrors({ ...errors, errDate: false }); // Clear error if a valid date is selected
    } else {
      setErrors({ ...errors, errDate: true }); // Show error if date is cleared
    }
  };

  return (
    <div className="col-12">
      {/* <SriyanshCardHeader Title="Indent Entry Edit" /> */}
      <Card className="Formcard" >
        {error && (
          <ToasterAlerts
            type="error"
            title="Messasge"
            errorMessage={error}
            displaytime={2000}
            handleClose={() => {
              setError("");
            }}
          />
        )}

<div className="input-groupHeading">
Indent Entry Edit

            </div>
        <CardContent >
          <div className="row" >
            <div className="container">
              <div className="input-group mt-2">
                <CustomTextField
                  label="Enter Indent Number (Max 50 Character)*"
                  value={varindentNumber}

//onChange={(newValue) => setText(newValue)}

// onChange={(e) => {
//   const sanitizedValue = e.target.value
//     .replace(/^\s+/, "") // Remove leading spaces
//     .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space
//   setvarindentNumber(sanitizedValue); // Update the state with the sanitized value
// }}


                  onChange={(e) => {
                    setvarindentNumber(e.target.value.toUpperCase());
                  }}
                  placeholder="Enter Indent Number (Max 50 Character)*"
                  maxLength={50} // Set the maximum length
                  multiline={false} // Enable multiline
                  //   minRows={4} // Set the minimum number of rows
                  error={!!errors.indent}
                  helperText={errors.indent}
                />
              </div>

              <div className="input-group" style={{ marginTop: "7px" }}>
                <DatePickerComponent 
                  label="Date of Indent*"
                  id="indentdate"
                  value={vardateofIndent}
                  onChange={(newDate) =>
                    handleDateChange(newDate, setvardateofIndent)
                  }
                  error={errors.errDate}
                  maxDate={today}
                  minDate={minCalDate}
                />
              </div>
            </div>
            <div className="container">
              <div className="input-group">
                <CustomTextField
                  label="Enter Item Name (Max 200 Character)*"
                  value={varitemname}
                  onChange={(e) => {
                    setvaritemname(e.target.value);
                  }}
                  placeholder="Enter Item Name (Max 200 Character)*"
                  maxLength={200} // Set the maximum length
                  multiline={true} // Enable multiline
                  minRows={3} // Set the minimum number of rows
                  error={!!errors.name}
                  helperText={errors.name}
                />
              </div>{" "}
            </div>
            <div className="container">
              <div className="input-group">
                <NumericTextField
                  id="ItemQuantity"
                  label="Item Quantity"
                  title="Item Quantity"
                  error={errors.qty}
                  value={varindentItemQty}
                  onChange={handleQuantityChange}
                />
              </div>
              <div className="input-group">
                <DropdownfromDatabaseList
                  Options={units}
                  option={unit}
                  setOptionValue={setunit}
                  DisplayItem1="unit"
                  DisplayItem2="unitcode"
                  showKeyInLabel={true}
                />
              </div>

              <div className="input-group">
                <NumericTextField
                  id="ItemValue"
                  label="Item Value"
                  title="Item Value"
                  error={errors.val}
                  value={varindentItemValue}
                  onChange={handleValueChange}
                />
              </div>
            </div>
            <div className="container">
              <div className="input-group">
                <DropdownfromDatabaseList
                  Options={consignees}
                  option={consignee}
                  setOptionValue={setconsignee}
                  DisplayItem1="Shop"
                  DisplayItem2="ConsigneeCode"
                  showKeyInLabel={true}
                  disabled={auth?.userrights === USER_RIGHTS.CONSIGNEE} // disabled is true if user is not equal to "user"
                />
              </div>
            </div>
            {/* ------------------- Urgent Start -----------------*/}
            {urights === 1 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    border: "2px solid red",
                    padding: "10px 20px",
                    borderRadius: "8px",
                    textAlign: "center",
                    color: "red",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        color="primary"
                      />
                    }
                    label="Select If Indent is Urgent Nature"
                  />
                </div>
              </div>
            )}
            ;{/* ------------------- Urgent END -----------------*/}
          </div>

          <>
            <div
              className=" container flex"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                //height: '100vh', // Full viewport height
              }}
            >
              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={UpdateIndentData}
                title="Click for Data Update"
              >
                Update Data
              </button>

              <button
                className="button button1"
                type="button" // Updated type attribute to "button"
                onClick={handleClose}
                title="Click for Data Save"
                style={{ backgroundColor: "red", color: "white" }}
              >
                Close
              </button>
            </div>
          </>
        </CardContent>
      </Card>
    </div>
  );
}

export default IndentEdit;
